import APIService from '@/api'

export default class APIPaymentMethodType extends APIService{

    constructor(){
        super('paymentmethodtypes')
    }

    getAll() {
        var response = this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }
}


// WEBPACK FOOTER //
// ./src/api/paymentmethodtype.js